import styled, { keyframes } from "styled-components";

const fadeInUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(12px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const LazyItem = styled.div`
    animation: ${fadeInUp} 380ms ease;
`;

export const Sentinel = styled.div`
    height: 1px;
`;
